import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e471ed9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "variant-selector-wrapper" };
const _hoisted_2 = { class: "variant-selector-wrapper__header" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Variants", -1 /* HOISTED */));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-cog" }, null, -1 /* HOISTED */));
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-cog" }, null, -1 /* HOISTED */));
const _hoisted_7 = [
    _hoisted_6
];
import { useCampaignVariants } from "src/shared/store/campaign-built/composables/useCampaignVariants";
import { computed, toRef } from "vue";
import DisplayedCampaignVariantSelectorItem from "./DisplayedCampaignVariantSelectorItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DisplayedCampaignVariantSelector',
    props: {
        campaignId: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { variants } = useCampaignVariants(toRef(props, "campaignId"));
        const isCampaignEditor = computed(() => {
            return window.location.pathname.includes("/campaign/edit");
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    (isCampaignEditor.value)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/${_ctx.campaignId}/details`
                        }, {
                            default: _withCtx(() => [
                                _hoisted_4
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["to"]))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: `/campaign/edit/#/${_ctx.campaignId}/details`
                        }, _hoisted_7, 8 /* PROPS */, _hoisted_5))
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(variants), (variant) => {
                            return (_openBlock(), _createBlock(DisplayedCampaignVariantSelectorItem, {
                                key: variant,
                                "campaign-id": _ctx.campaignId,
                                variant: variant
                            }, null, 8 /* PROPS */, ["campaign-id", "variant"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
